import React, { useCallback, useState, } from "react";
import { addCartItems, emptyCart, removeCartItems, updateCart, updateCartItem, addDiscountCode, removeDiscountCode, addCartItem, addNote, editNote, removeNote, } from "@ludens-reklame/rubics-v3-sdk/cart";
const nullCart = {
    _id: "",
    created: "",
    lastUpdated: "",
    items: [],
    discountCodes: [],
    meta: [],
    notes: [],
    total: 0,
    totalTax: 0,
    totalDiscount: 0,
    totalText: "",
    totalDiscountText: "",
    totalTaxText: "",
    billing: {},
    shipping: {},
    taxLines: [],
    discountLines: [],
    valid: true,
    invalidReasons: [],
};
// {} as IStoreContext is a hack, as it actually is not necessary to provide default values here
export const CartContext = React.createContext({});
export const CartContextProvider = ({ initialCart, children }) => {
    const [_cart, setCart] = useState(initialCart || nullCart);
    const [networking, setNetworking] = useState(false);
    const networkWrapper = useCallback(async (fn) => {
        setNetworking(true);
        const newCart = await fn();
        setCart(newCart);
        setNetworking(false);
    }, []);
    const update = useCallback(async (cart) => {
        await networkWrapper(() => updateCart(cart));
    }, [networkWrapper]);
    const addItems = useCallback(async (items) => {
        await networkWrapper(() => addCartItems(items, _cart));
    }, [_cart, networkWrapper]);
    const addItem = useCallback(async (item) => {
        setNetworking(true);
        const response = await addCartItem(item, _cart);
        setCart(response.cart);
        setNetworking(false);
        return response.item;
    }, [_cart, networkWrapper]);
    const removeItems = useCallback(async (ids) => {
        await networkWrapper(() => removeCartItems(_cart, ids));
    }, [_cart, networkWrapper]);
    const updateItem = useCallback(async (id, item) => {
        await networkWrapper(() => updateCartItem(_cart, id, item));
    }, [_cart, networkWrapper]);
    const _addDiscountCode = useCallback(async (code) => {
        await networkWrapper(() => addDiscountCode(_cart, code));
    }, [_cart, networkWrapper]);
    const _removeDiscountCode = useCallback(async (code) => {
        await networkWrapper(() => removeDiscountCode(_cart, code));
    }, [_cart, networkWrapper]);
    const _addNote = useCallback(async (content) => {
        await networkWrapper(() => addNote(_cart, content));
    }, [_cart, networkWrapper]);
    const _editNote = useCallback(async (id, content) => {
        await networkWrapper(() => editNote(_cart, id, content));
    }, [_cart, networkWrapper]);
    const _removeNote = useCallback(async (id) => {
        await networkWrapper(() => removeNote(_cart, id));
    }, [_cart, networkWrapper]);
    const empty = useCallback(async () => {
        await networkWrapper(emptyCart);
    }, [_cart, networkWrapper]);
    return (React.createElement(CartContext.Provider, { value: {
            cart: _cart,
            networking,
            update,
            addItems,
            addItem,
            removeItems,
            updateItem,
            addDiscountCode: _addDiscountCode,
            removeDiscountCode: _removeDiscountCode,
            addNote: _addNote,
            editNote: _editNote,
            removeNote: _removeNote,
            empty,
        } }, children));
};
